import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslationEntryObject } from '@app/shared/models/translatable';
import { CredentialsType } from '@app/shared/models/credentials';
import { ProvidersService } from '@app/core/services/providers.service';
import { BaseList } from '@app/shared/models/list';
import { EmailProvider } from '@app/shared/models/email-provider';

@Component({
    templateUrl: './third-party-credentials-management.component.html',
    styleUrls: ['./third-party-credentials-management.component.scss']
})
export class ThirdPartyCredentialsManagementComponent extends BaseWithBundleComponent
                                                      implements OnInit, OnDestroy {

    public thirdPartyCredentialsList: TranslationEntryObject[];
    public selectedThirdPartyCredentials: TranslationEntryObject;
    public emailProviders: BaseList<EmailProvider>;

    get selectedCredentialsType(): CredentialsType {
        return this.selectedThirdPartyCredentials ? this.selectedThirdPartyCredentials.key as CredentialsType : null;
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle, protected providersService: ProvidersService) {
        super(componentServiceBundle);
        this._idPrefix = 'third_party_cred.';
    }

    public ngOnInit() {
        super.ngOnInit();

        this.thirdPartyCredentialsList = [
            new TranslationEntryObject({ key: CredentialsType.EMAIL, trans: marker('third_party_credentials_management.menu_option.email_provider_settings')})
        ];

        this.providersService.getEmailProviders()
                             .subscribe((emailProviderList) => {
            this.emailProviders = emailProviderList;
            this.selectThirdPartyCredential(this.thirdPartyCredentialsList[0]);
        });
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    public selectThirdPartyCredential(item: TranslationEntryObject): void {
        this.selectedThirdPartyCredentials = item;
    }

}
